import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { makeRequestAuth } from "../../../_config/api";

const BarChartTouch = () => {
    const [fetchedData, setFetchedData] = useState({ categories: [], data: [] });
    const [year, setYear] = useState("2026");
    const [status, setStatus] = useState("");

    const years = ["2025", "2026", "2027", "2028", "2029", "2030"];
    const statuses = ["All", "pending", "approved", "rejected",];

    useEffect(() => {
        const fetchChartData = async () => {
            try {
                const resData = { year: year, status: status === "All" ? "" : status };
                const response = await makeRequestAuth("post", "/admin/touchChart", resData);

                if (response?.code === 0 && !response.error) {
                    setFetchedData(response.data);
                } else {
                    console.error("Server Error:", response?.data?.message || "Unknown error");
                }
            } catch (error) {
                console.error("Request Failed:", error);
            }
        };

        fetchChartData();
    }, [year, status]);

    const chartCategories = Array.isArray(fetchedData?.categories) ? fetchedData.categories : [];
    const chartData = Array.isArray(fetchedData?.data) ? fetchedData.data : [];

    const chartOptions = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        xaxis: {
            categories: chartCategories,
            labels: {
                style: {
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#6b7280",
                },
            },
        },
        yaxis: {
            tickAmount: 4,
            min: 0,
            max: Math.max(...chartData, Math.max(...fetchedData?.data)),
            labels: {
                formatter: (val) => `${val}`,
                style: {
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#6b7280",
                },
            },
        },
        grid: {
            yaxis: { lines: { show: false } },
        },
        colors: ["#ffbf1a"],
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                gradientToColors: ["#ff4080"],
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100],
            },
        },
        plotOptions: {
            bar: {
                columnWidth: "35%",
                borderRadius: 5,
            },
        },
        dataLabels: {
            enabled: false,
        },
        tooltip: {
            theme: "light",
        },
    };

    const chartSeries = [
        {
            name: "Bookings",
            data: chartData,
        },
    ];

    return (
        <div className="bg-white p-4 rounded-2xl shadow-md w-full mx-auto">
            <div className="flex flex-wrap justify-between items-center mb-4 gap-2">
                <h2 className="text-sm font-semibold text-gray-700">
                    Total Touch By Month
                </h2>

                <div className="flex gap-2 flex-wrap">
                    <select
                        className="px-3 py-1 rounded border border-gray-300 text-sm text-gray-700"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                    >
                        {years.map((y) => (
                            <option key={y} value={y}>{y}</option>
                        ))}
                    </select>

                    <select
                        className="px-3 py-1 rounded border border-gray-300 text-sm text-gray-700"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        {statuses.map((s) => (
                            <option key={s} value={s}>
                                {s.charAt(0).toUpperCase() + s.slice(1)}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={235}
            />
        </div>
    );
};

export default BarChartTouch;
